/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { templateStrings } from "../../../../Constant";
import { TableWrapper } from "../../../../shared/layout";
import { fetchAllOperatorExpensesAction } from "../../../../redux/action-creators/expenseActionCreator";
import ExpenseModal from "./ExpenseModal";

function ExpenseList(props) {
  const {
    headerLoader,
    content,
    totalItems,
    selectedDateFilter,
    refresh,
    setRefresh,
    FetchAllOperatorExpenses,
    operatorFilter,
    cityFilter,
  } = props;

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNo, setPageNo] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [selected, setSelected] = useState([""]);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState({});

  const templateString = templateStrings.reportExpense;

  const getList = useCallback(() => {
    FetchAllOperatorExpenses({
      pageNo,
      pageSize: rowsPerPage,
      operatorFilter,
      cityFilter,
      dateFilter: selectedDateFilter,
    });
  }, [props, rowsPerPage, pageNo, selectedDateFilter]);

  useEffect(() => {
    getList();
  }, [operatorFilter, cityFilter, selectedDateFilter, rowsPerPage, pageNo]);

  useEffect(() => {
    if (refresh) {
      getList();
      setRefresh(false);
    }
  }, [refresh]);

  const handleAction = useCallback(
    (actionProps) => {
      setRowData(actionProps);
      setOpen(!open);
    },
    [open],
  );

  const handleChange = useCallback(
    (input, value) => {
      switch (input) {
        case "pageNo":
          setPageNo(value);
          break;
        case "rowsPerPage":
          setRowsPerPage(value);
          break;
        case "selected":
          setSelected(value);
          break;
        default:
          break;
      }
    },
    [],
  );

  return (
    <>
      <TableWrapper
        content={!headerLoader && content}
        selected={selected}
        pageNo={pageNo}
        uniqueKey="busNumber"
        rowsPerPage={rowsPerPage}
        count={totalItems}
        handleChange={handleChange}
        templateString={templateString}
        selectionAllowed={false}
        actionName="Edit"
        handleAction={handleAction}
      />
      {open && (
        <ExpenseModal
          open={open}
          setOpen={setOpen}
          rowData={rowData}
          setRefresh={setRefresh}
        />
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Expenses
        && state.Expenses.allOperatorsExpenses
        && state.Expenses.allOperatorsExpenses.items)
      || [],
    totalItems:
      (state
        && state.Expenses
        && state.Expenses.allOperatorsExpenses
        && state.Expenses.allOperatorsExpenses.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch) => ({
  FetchAllOperatorExpenses: (params) => {
    dispatch(fetchAllOperatorExpensesAction(params));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ExpenseList));
